module.exports = __webpack_public_path__ + "img/so.15978724.svg";